import styled from 'styled-components';

export const SelectBoxStyled = styled.div`
    .left-panel-shrink-nav.fullNav {
        padding: 0 8px 0 0;

        .left-panel-shrink-col1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        img {
            cursor: pointer;
            padding: 1rem;
        }
    }

    .left-panel-shrink-nav.l-shrink.row .dropdown-menu.show {
        top: 0px !important;
    }

         .left-panel-shrink-nav.ex-shrink-playlist .dropdown-menu.show {
         top: 0px !important;
         left: 50px !important;
     }
 
     .left-panel-shrink-nav.ex-shrink .dropdown-menu.show {
         top: 0px !important;
         left: 50px !important;
     }

    position: relative;

    .dropdown-toggle.btn.btn-secondary, .dropdown-toggle.btn.btn-secondary:focus,
    .dropdown-toggle:focus {
        background: transparent;
        border: none;
        font-size: 24px;
        color: var(--rf-text-primary, #111827);
        box-shadow: none !important;
        outline: none !important;
        outline-offset: 0 !important;
        -webkit-focus-ring-color: transparent !important;
    }

    .dropdown-menu.show {
        display: block;
        top: 0px !important;
        left: 50px !important;
        background: var(--rf-surface, #FFFFFF);
        border: 1px solid var(--rf-border, #E5E7EB);
        border-radius: var(--rf-radius-md, 12px);
        font-size: 14px;
        line-height: 21px;
        box-shadow: var(--rf-shadow-md);
        color: var(--rf-text-primary, #111827);

        button:focus {
            outline: 0;
        }
    }

    .dropdown-item:hover, .dropdown-item:focus {
        text-decoration: none;
        background-color: var(--rf-primary-light, #EEF2FF);
        border-radius: 4px;
        margin: 8px auto;
        width: 90%;
    }

    .dropdown-item {
        border: 0;
        margin: 8px auto;
        width: 90%;
        transition: linear 1s;
    }

    .left-panel-shrink-col2-deals img {
        margin-top: 0px !important;
        cursor: pointer;
    }

    .left-panel-shrink-col2 img {
        margin-top: 10px !important;
    }

    .left-panel-shrink-nav.ex-shrink > div {
        padding: 10px 15px 12px 0;
    }

    .left-panel-shrink-nav.ex-shrink, .left-panel-shrink-nav.fullNav {
        align-items: center;

        .dropdown-toggle::after {
            margin-left: 0.355em;
            margin-top: 15px;
        }
    }

    /* Override global focus styles for dropdown toggle */

    .left-panel-shrink-nav .dropdown-toggle:focus {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
    }

    /* Additional overrides for all possible focus states */

    .left-panel-shrink-nav .dropdown-toggle:focus,
    .left-panel-shrink-nav .dropdown-toggle.focus,
    .left-panel-shrink-nav .dropdown-toggle:focus-visible {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
    }

    /* Override any Bootstrap focus styles */

    .left-panel-shrink-nav .btn:focus,
    .left-panel-shrink-nav .btn-secondary:focus,
    .left-panel-shrink-nav .dropdown-toggle.btn:focus {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
    }

    /* Most aggressive override for all possible focus states */

    .left-panel-shrink-nav .dropdown-toggle:focus,
    .left-panel-shrink-nav .dropdown-toggle.focus,
    .left-panel-shrink-nav .dropdown-toggle:focus-visible,
    .left-panel-shrink-nav .dropdown-toggle:focus-within,
    .left-panel-shrink-nav .dropdown-toggle:active,
    .left-panel-shrink-nav .dropdown-toggle:focus-visible:focus,
    .left-panel-shrink-nav .dropdown-toggle:focus:focus-visible {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
        outline-offset: 0 !important;
        outline-width: 0 !important;
        outline-style: none !important;
    }

    /* Override Bootstrap focus styles specifically */

    .left-panel-shrink-nav .btn-secondary:focus,
    .left-panel-shrink-nav .btn-secondary.focus,
    .left-panel-shrink-nav .dropdown-toggle.btn-secondary:focus,
    .left-panel-shrink-nav .dropdown-toggle.btn-secondary.focus {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
        outline-offset: 0 !important;
        outline-width: 0 !important;
        outline-style: none !important;
    }

    /* Global focus override for this specific dropdown */

    .left-panel-shrink-nav .dropdown-toggle:focus {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
        outline-offset: 0 !important;
        outline-width: 0 !important;
        outline-style: none !important;
    }

    /* Specific override for the meetings dropdown toggle */

    .meetings-dropdown-toggle:focus,
    .meetings-dropdown-toggle.focus,
    .meetings-dropdown-toggle:focus-visible,
    .meetings-dropdown-toggle:focus-within,
    .meetings-dropdown-toggle:active {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
        outline-offset: 0 !important;
        outline-width: 0 !important;
        outline-style: none !important;
    }

    /* Highest specificity override */

    .left-panel-shrink-nav .left-panel-shrink-col1 .dropdown-toggle.meetings-dropdown-toggle:focus,
    .left-panel-shrink-nav .left-panel-shrink-col1 .dropdown-toggle.meetings-dropdown-toggle.focus,
    .left-panel-shrink-nav .left-panel-shrink-col1 .dropdown-toggle.meetings-dropdown-toggle:focus-visible {
        outline: none !important;
        box-shadow: none !important;
        -webkit-focus-ring-color: transparent !important;
        border: none !important;
        outline-offset: 0 !important;
        outline-width: 0 !important;
        outline-style: none !important;
    }
`

export const MeetingSelectBoxStyled = styled.div`
    .left-panel-shrink-nav.fullNav {
        padding: 0 8px 0 0;

        .left-panel-shrink-col1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        img {
            cursor: pointer;
            padding: 9px 30px;
        }
    }

    .left-panel-shrink-nav.l-shrink.row .dropdown-menu.show {
        top: 0px !important;
    }

    .left-panel-shrink-nav.ex-shrink .dropdown-menu.show {
        top: 252px !important;
    }

    position: relative;

    .dropdown-toggle.btn.btn-secondary, .dropdown-toggle.btn.btn-secondary:focus,
    .dropdown-toggle:focus {
        background: transparent;
        border: none;
        font-size: 18px;
        color: var(--rf-text-primary, #111827);
    }

    .dropdown-menu.show {
        display: block;
        left: 50px !important;
        top: 10px !important;
        background: var(--rf-surface, #FFFFFF);
        border: 1px solid var(--rf-border, #E5E7EB);
        border-radius: var(--rf-radius-md, 12px);
        font-size: 14px;
        line-height: 21px;
        box-shadow: var(--rf-shadow-md);
        color: var(--rf-text-primary, #111827);

        button:focus {
            outline: 0;
        }
    }

    .dropdown-item:hover, .dropdown-item:focus {
        text-decoration: none;
        background-color: var(--rf-primary-light, #EEF2FF);
        border-radius: 4px;
        margin: 8px auto;
        width: 90%;
    }

    .dropdown-item {
        border: 0;
        margin: 8px auto;
        width: 90%;
        transition: linear 1s;
    }

    .left-panel-shrink-col2 img {
        margin-top: 0px;
    }

    .left-panel-shrink-nav.ex-shrink > div {
        padding: 10px 15px 12px 0;
    }

    .left-panel-shrink-nav.ex-shrink, .left-panel-shrink-nav.fullNav {
        align-items: center;

        .dropdown-toggle::after {
            margin-left: 0.355em;
            margin-top: 15px;
        }
    }

`
export const ProfileImageBox = styled.div `
.circular-lmg {
    width: 24px !important;
    font-size: 11px;
    height: 24px !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    position: relative !important;
    overflow: hidden !important;
    border-radius: 50% !important;
    line-height: 1;
    letter-spacing: 0;
    text-indent: 0;

    > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        letter-spacing: 0;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}`

export const StyledChatBox = styled.div `
footer.StickyFooter {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  border-top: solid 1px #efefef;
}
  
.MessageForm {
  margin-left: 10px;
}
  
.MessageBox {
  float: left;
  width: 98%;
  margin: 5px 0 0 2%;
}
  
.MessageBox .ChatMessage {
  width: 80%;
  min-height: 40px;
}
  
.MessageBox .ChatMessage .RightBubble {
  position: relative;
  background: #dcf8c6;
  border-top-left-radius: .4em;
  border-bottom-left-radius: .4em;
  border-bottom-right-radius: .4em;
  padding: 5px 10px 10px;
  left: 15%;
}
  
.MessageBox .ChatMessage .RightBubble span.MsgName {
  font-size: 12px;
  font-weight: bold;
  color: green;
}
.MessageBox .ChatMessage .RightBubble span.MsgDate {
  font-size: 10px;
}
  
.MessageBox .ChatMessage .RightBubble:after {
  content: '';
  position: absolute;
  right: 0;
  top: 13px;
  width: 0;
  height: 0;
  border: 27px solid transparent;
  border-left-color: #dcf8c6;
  border-right: 0;
  border-top: 0;
  margin-top: -13.5px;
  margin-right: -27px;
}
.MessageBox .ChatMessage .LeftBubble {
  position: relative;
  background: lightblue;
  border-top-right-radius: .4em;
  border-bottom-left-radius: .4em;
  border-bottom-right-radius: .4em;
  padding: 5px 10px 10px;
  left: 5%;
}
.MessageBox .ChatMessage .LeftBubble span.MsgName {
  font-size: 12px;
  font-weight: bold;
  color: blue;
}
.MessageBox .ChatMessage .LeftBubble span.MsgDate {
  font-size: 10px;
}
.MessageBox .ChatMessage .LeftBubble:after {
  content: '';
  position: absolute;
  left: 0;
  top: 13px;
  width: 0;
  height: 0;
  border: 27px solid transparent;
  border-right-color: lightblue;
  border-left: 0;
  border-top: 0;
  margin-top: -13.5px;
  margin-left: -27px;
}
  
.MessageBox .ChatStatus {
  min-height: 49px;
}

.MessageBox .ChatStatus .ChatDate {
  display: block;
  font-size: 10px;
  font-style: italic;
  color: #777;
  height: 15px;
  left: 10%;
  right:10%;
}
  
.MessageBox .ChatStatus .ChatContentCenter {
  padding: 5px 10px;
  background-color: #e1e1f7;
  border-radius: 6px;
  font-size: 12px;
  color: #555;
  height: 34px;
  left: 10%;
  right:10%;
}

.ChatContent {
  overflow-y: scroll;
  height: 600px;
}

`